import React, { useState, useEffect } from "react";
import "./custom.css"; // Custom CSS for styling
import DocumentationViewer from "../components/DocumentationViewer";
import { useNavigate, useParams } from "react-router-dom";
import { markdownPaths } from "../types/markdownPaths";

// Define the available sections as a union type for better typing
type Section = "commercials" | "developers";

const GettingStartedPage: React.FC = () => {
  const navigate = useNavigate();
  const { section } = useParams<{ section: Section }>();
  const [selectedSection, setSelectedSection] =
    useState<Section>("commercials");

  // Update the selected section based on the URL parameter
  useEffect(() => {
    if (section) {
      setSelectedSection(section);
    }
  }, [section]);

  // Function to switch sections and update the URL
  const handleSectionChange = (section: Section) => {
    setSelectedSection(section);
    navigate(`/knowledge-hub/getting-started/${section}`);
  };

  return (
    <div className="api-concepts-page">
      {/* Horizontal Menu with Section Categories */}
      <nav className="api-concepts-menu bg-gray-100 p-4">
        <ul className="flex justify-center space-x-8">
          <li
            className={`cursor-pointer ${
              selectedSection === "commercials"
                ? "text-green-600 font-bold"
                : ""
            }`}
            onClick={() => handleSectionChange("commercials")}
          >
            Commercials
          </li>
          <li
            className={`cursor-pointer ${
              selectedSection === "developers" ? "text-green-600 font-bold" : ""
            }`}
            onClick={() => handleSectionChange("developers")}
          >
            Developers
          </li>
        </ul>
      </nav>

      {/* Content Area */}
      <div className="content-area">
        {selectedSection === "commercials" && (
          <DocumentationViewer
            filePath={markdownPaths.GettingStartedCommercialsURL}
          />
        )}

        {selectedSection === "developers" && (
          <DocumentationViewer
            filePath={markdownPaths.GettingStartedDevelopersURL}
          />
        )}
      </div>
    </div>
  );
};

export default GettingStartedPage;
